import { render } from "./SolicitarRoteiro.vue?vue&type=template&id=c74fadc8&lang=pug"
const script = {}

import "./SolicitarRoteiro.vue?vue&type=style&index=0&id=c74fadc8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__